import { styled } from "@mui/material/styles";
import Switch, { SwitchProps } from "@mui/material/Switch";

export type IOSSwitchProps = SwitchProps & {
	variant?: "filled" | "thumbOnly";
	color?: "primary" | "secondary";
};

const IOSSwitch = styled(({ variant = "thumbOnly", color = "primary", ...props }: IOSSwitchProps) => (
	<Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))((value) => {
	return {
		width: 36,
		height: 20,
		padding: 0,
		"& .MuiSwitch-switchBase": {
			padding: 0,
			margin: 2,
			transitionDuration: "300ms",
			"&.Mui-checked": {
				transform: "translateX(16px)",
				"& + .MuiSwitch-track": {
					backgroundColor:
						value.variant === "thumbOnly"
							? value.color === "secondary"
								? value.theme.palette.surface.main
								: value.theme.palette.primary.main
							: value.theme.palette[value.color ?? "primary"].main,
					opacity: 1,
					border: 0,
				},
				"&.Mui-disabled + .MuiSwitch-track": {
					opacity: 0.5,
				},
			},
			"&.Mui-focusVisible .MuiSwitch-thumb": {
				border: "6px solid #fff",
			},
			"&.Mui-disabled, .MuiSwitch-thumb": {
				color:
					value.variant === "thumbOnly"
						? value.color === "secondary"
							? value.theme.palette.secondary.main
							: value.theme.palette.grey[100]
						: value.theme.palette.surface.main,
			},
			"&.Mui-disabled + .MuiSwitch-track": {
				opacity: value.theme.palette.mode === "light" ? 0.7 : 0.3,
			},
		},
		"& .MuiSwitch-thumb": {
			boxSizing: "border-box",
			width: 16,
			height: 16,
		},
		"& .MuiSwitch-track": {
			borderRadius: 20 / 2,
			backgroundColor:
				value.variant === "thumbOnly"
					? value.color === "secondary"
						? value.theme.palette.surface.main
						: "#E9E9EA"
					: "#0000001F",
			opacity: 1,
			transition: value.theme.transitions.create(["background-color"], {
				duration: 500,
			}),
		},
	};
});

export default IOSSwitch;
